__turbopack_context__.v({
  "Break": "ZMqkwa_Break",
  "Item": "ZMqkwa_Item",
  "ItemChevron": "ZMqkwa_ItemChevron",
  "Link": "ZMqkwa_Link",
  "LinkActive": "ZMqkwa_LinkActive",
  "LinkChevron": "ZMqkwa_LinkChevron",
  "LinkChevronLeft": "ZMqkwa_LinkChevronLeft",
  "LinkChevronRight": "ZMqkwa_LinkChevronRight",
  "LinkDisabled": "ZMqkwa_LinkDisabled",
  "List": "ZMqkwa_List",
  "Pagination": "ZMqkwa_Pagination",
});
